export default "__VITE_ASSET__BTtAtLvu__"